<template>
  <div class="user-card card">
    <div class="p-3 card-body">
      <div class="d-flex mt-n2 py-2">
        <div
          class="mt-n4 overflow-hidden flex-shrink-0"
        >
          <div class="img placeholder" />
        </div>
        <div class="my-auto ms-3">
          <h6 class="m3-0 placeholder">
            Gebruikersnaam
          </h6>
          <p class="text-xs mb-0 placeholder">
            Clubnaam
          </p>

          <div
            class="d-flex gap-2 mt-2"
          >
            <material-badge
              v-if="isAdmin"
              size="sm"
              color="dark"
            >
              Placeholder
            </material-badge>
            
            <material-badge
              v-if="boardMemberFunction"
              size="sm"
              color="secondary"
            >
              {{ boardMemberFunction }}
            </material-badge>

            <material-badge
              v-if="isActivated"
              size="sm"
              color="success"
            >
              Actief
            </material-badge>
          </div>
        </div>
        <div class="ms-auto">
          <i class="d-block text-lg fa fa-ellipsis-v"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialBadge from '@/components/MaterialBadge.vue';

export default {
  name: 'UserCard',

  components: {
    MaterialBadge,
  },
};
</script>

<style scoped lang="scss">
.user-card {
  height: 100%;

  h6.placeholder {
    display: block;;
  }
  
  div.img {
    width: 75px;
    height: 75px;
    border-radius: 0.5rem;
    background-color: #bcbfcc;
  }

  .badge {
    color: transparent;
  }
}
</style>
